import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Button from "@mui/material/Button";
import MDBox from "common/components/MDBox";
import "./style.css";

const HeaderNavigator = ({ activeTab, setActiveTab }) => {

    const [register, setRegister] = useState(false);
    const [fullPay, setFullPay] = useState(false);
    const [installment, setInstallment] = useState(false);

    const getPayment = useSelector((state) => state.getAllPaymentSlice.payment);

    useEffect(() => {
        if (getPayment.isSuccess && getPayment.data) {
            const regData = getPayment.data;
            const paymentData = regData.registration_data.payment_data;
            const reg_fee_enabled = regData.registration_data.intake_data.reg_fee === 1;

            const hasRegistration = paymentData.some(val => val.status === 'registration');
            const hasInstallment = paymentData.some(val => val.status === 'installment');
            const hasFullPayment = paymentData.some(val => val.status === 'full-payment');
            const amountDue = regData.amount_due;

            // Case 1: Fully paid
            if (amountDue === 0 || hasFullPayment) {
                setRegister(true);
                setFullPay(true);
                setInstallment(true);
                setActiveTab("installment");
                return;
            }

            // Case 2: No payments yet, but registration fee is required
            if (paymentData.length === 0 && reg_fee_enabled) {
                setRegister(false);
                setFullPay(true);
                setInstallment(true);
                setActiveTab("registration");
                return;
            }

            // Case 3: Registration paid, now full payment only
            if (hasRegistration && !hasInstallment && !hasFullPayment) {
                setRegister(true);
                setFullPay(false);
                setInstallment(false);
                setActiveTab("full-payment");
                return;
            }

            // Case 4: Registration + installment payments started (ongoing)
            if ((hasRegistration || !reg_fee_enabled) && (hasInstallment && !hasFullPayment)) {
                setRegister(true);
                setFullPay(true);
                setInstallment(false);
                setActiveTab("installment");
                return;
            }

            if (!reg_fee_enabled && paymentData.length === 0) {
                setRegister(true);        // Disable Registration (not needed)
                setFullPay(false);        // Enable Full Payment
                setInstallment(false);    // Enable Installment
                setActiveTab("full-payment");
                return;
            }

        }
    }, [getPayment.data]);

    return (
        <div className="headerNavbar-button" style={{ overflow: "auto", maxHeight: "100vh" }}>
            <MDBox
                sx={{
                    borderRadius: 4,
                    display: "flex",
                    overflow: "auto",
                    bgcolor: "#F4F4F4",
                    minWidth: { xl: "100%", lg: "100%", md: "350px", xs: "100%" },
                    margin: "0 auto",
                    p: 1,
                }}
            >
                <Button
                    sx={{ pr: 3, pl: 3 }}
                    disabled={register}
                    color="inherit"
                    size="small"
                    variant={activeTab === "registration" ? "contained" : ""}
                    onClick={() => setActiveTab("registration")}
                >
                    Registration Fee
                </Button>{" "}
                &nbsp;
                <Button
                    sx={{ pr: 3, pl: 3 }}
                    disabled={fullPay}
                    color="inherit"
                    size="small"
                    variant={activeTab === "full-payment" ? "contained" : ""}
                    onClick={() => setActiveTab("full-payment")}
                >
                    Full Payment
                </Button>{" "}
                &nbsp;
                <Button
                    sx={{ pr: 3, pl: 3 }}
                    disabled={installment}
                    color="inherit"
                    size="small"
                    variant={activeTab === "installment" ? "contained" : ""}
                    onClick={() =>
                        setActiveTab("installment")
                    }
                >
                    Instalment payment
                </Button>
            </MDBox>
        </div>
    );
};

export default HeaderNavigator;
